/** Z-index layers to prevent UI overlap (dialogs, menu, game UI). */
export const zIndexLayers = {
  base: 1,
  gameUI: 10,
  videoOverlay: 15,
  chat: 100,
  menu: 200,
  dialogs: 1200,
  mainMenu: 1050,
  // The bottom game bar must stay above every in-world video tile (they reach 1010 in
  // LiveKitVideoDisplay.styles.ts) but below the guest footer, mainMenu and dialogs.
  toolbars: 1020,
  overlays: 500,
  modals: 2000,
  topLevel: 3000,
} as const
